<template>
    <div class="page_mobile_join flex-col">
        <!-- 顶部图片 -->
        <div class="box_2">
            <div class="block_image_wrapper">
                <div class="block_image flex-col"></div>
            </div>
        </div>

        <!-- 五个特点展示 -->
        <div class="box_5 flex-col">
            <div class="block_grid flex-col">
                <!-- 使用统一的grid布局 -->
                <div class="features-grid">
                    <!-- 第一行三个特点 -->
                    <div class="feature-item">
                        <div class="box_7 flex-col">
                            <div class="image-text_1 flex-col">
                                <img class="image_2" referrerpolicy="no-referrer" src="../../../assets/contact/contact_01.png"/>
                                <span class="text-group_2">选拔</span>
                            </div>
                            <span class="paragraph_174">举贤任能&nbsp;德才兼备<br />适岗为要&nbsp;多元包容</span>
                        </div>
                    </div>
                    <div class="divider-line"></div>
                    <div class="feature-item">
                        <div class="image-text_2 flex-col">
                            <img class="image_4" referrerpolicy="no-referrer" src="../../../assets/contact/contact_02.png"/>
                            <div class="text-group_3 flex-col">
                                <span class="text_12">使用</span>
                                <span class="paragraph_174">人尽其才&nbsp;才尽其用<br />动态调配&nbsp;绩优则上</span>
                            </div>
                        </div>
                    </div>
                    <div class="divider-line"></div>
                    <div class="feature-item">
                        <div class="image-text_2 flex-col">
                            <img class="image_4" referrerpolicy="no-referrer" src="../../../assets/contact/contact_03.png"/>
                            <div class="text-group_4 flex-col">
                                <span class="text_12">培养</span>
                                <span class="paragraph_174">因材施教&nbsp;挖掘潜力<br />创新赋能&nbsp;终身成长</span>
                            </div>
                        </div>
                    </div>

                    <!-- 第二行两个特点 -->
                    <div class="feature-item">
                        <div class="box_7 flex-col">
                            <div class="image-text_1 flex-col">
                                <img class="image_2" referrerpolicy="no-referrer" src="../../../assets/contact/contact_04.png"/>
                                <span class="text-group_2">激励</span>
                            </div>
                            <span class="paragraph_174">意愿开发&nbsp;目标导向<br />长效激励&nbsp;实现双赢</span>
                        </div>
                    </div>
                    <div class="divider-line" style="margin-top: 10px;margin-bottom: 5px"></div>
                    <div class="feature-item">
                        <div class="image-text_2 flex-col">
                            <img class="image_4" referrerpolicy="no-referrer" src="../../../assets/contact/contact_05.png"/>
                            <div class="text-group_4 flex-col">
                                <span class="text_12">保留</span>
                                <span class="paragraph_174">文化引领&nbsp;氛围影响<br />情感共鸣&nbsp;价值共创</span>
                            </div>
                        </div>
                    </div>
                    <div class="divider-line hidden"></div> <!-- 空div保持对齐 -->
                </div>
            </div>
        </div>

        <!-- 底部内容 -->
        <div class="box_9 flex-col">
            <!-- 团队建设 -->
            <div class="block_6 flex-row justify-between">
                <div class="section_3 flex-col"></div>
                <div class="text-wrapper_4 flex-col">
                    <span class="text_16">团队建设</span>
                    <span class="paragraph_6">
                        在康柏，团队建设一直是企业发展的核心基石
                        <br />
                        <br />
                        我们会为员工提供多样化的学习机会和资源，提供各种培训支持，致力于全面挖掘员工个人综合素质的潜能；
                        <br />
                        <br />
                        我们有成熟的绩效文化和人才发展晋升通道，为员工提供一个挑战与机遇并存的职业环境；
                        <br />
                        <br />
                        我们有多样化的文化活动，为员工营造舒适和谐的氛围，为员工间建立良好的沟通了解基础。
                      </span>
                </div>
            </div>

            <!-- 员工关怀 -->
            <div class="block_7 flex-row justify-between">
                <div class="box_10 flex-col"></div>
                <div class="box_11 flex-col">
                    <span class="text_17">员工关怀</span>
                    <div class="text-wrapper_5">
                        <span class="paragraph_1">
                          在康柏，员工关怀一直是企业秉持的重要理念
                          <br />
                          <br />
                          我们会为员工提供健康舒适的办公环境，配备良好设施；
                          <br />
                          <br />
                          我们会为员工提供具有竞争力的薪酬待遇，提供
                        </span>
                        <span class="text_18">弹性工作制度、带薪休假等福利</span>
                        <span class="paragraph_1">
                          ；
                          <br />
                          <br />
                          除国家规定的基本福利以外，我们还提供多项其他福利，例如
                        </span>
                        <span class="text_18">节日福利、福利假期、福利体检、员工旅游</span>
                        <span class="text_18">等。</span>
                    </div>
                </div>
            </div>

            <!-- 加入我们 -->
            <div class="block_8 flex-row justify-between">
                <img class="image_10" referrerpolicy="no-referrer" src="../../../assets/contact/contact_link.png"/>
                <div class="text-group_7 flex-col">
                    <span class="text_21">期待您的加入</span>
                    <div class="text-wrapper_6">
                        <span class="text_22">请将个人简历发</span>
                        <span class="text_23">至</span>
                        <span class="text_24">zhaopin&#64;bjchpc.com</span>
                        <span class="text_25">&nbsp;&nbsp;或在boss直聘上搜索康柏汉森查询相应职位。</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        methods: {}
    };
</script>

<style scoped lang="css">
    /* 基础样式 */
    .page_mobile_join {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .justify-between {
        justify-content: space-between;
    }

    /* 顶部图片区域 */
    .box_2 {
        width: 100%;
        align-content: center;
    }

    .block_image_wrapper {
        width: 100%;
        height: 20vw;
        max-height: 165px;
        overflow: hidden;
        margin: 0 auto;
    }

    .block_image {
        background-image: url(../../../assets/contact/contact_join_01.png);
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        transition: transform 0.3s ease;
    }

    .block_image_wrapper:hover .block_image {
        transform: scale(1.05);
    }

    /* 五个特点展示区域 */
    .box_5 {
        width: 100%;
        align-items: center;
        padding: 2vw 0;
    }

    .block_grid {
        background-color: rgba(255, 255, 255, 1);
        padding: 2vw;
        box-shadow: 0px 0px 30px 0px rgba(0,0,0,0.1);
        border-radius: 0px 0px 9px 9px;
        width: 90%;
        margin: 0 auto;
    }

    /* 新的网格布局 */
    .features-grid {
        display: grid;
        grid-template-columns: 1fr 1px 1fr 1px 1fr;
        width: 100%;
    }

    .feature-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 1vw;
    }

    .divider-line {
        background: #E0E0E0;
        width: 1px;
        height: 100%;
        margin: 0 auto;
    }

    .divider-line.hidden {
        visibility: hidden;
    }

    .image_2, .image_4 {
        width: 8vw;
        height: 8vw;
        max-width: 53px;
        max-height: 50px;
    }

    .text-group_2, .text_12 {
        color: rgba(0, 134, 131, 1);
        font-size: clamp(16px, 4vw, 28px);
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 1.4;
        white-space: nowrap;
    }

    .paragraph_174 {
        color: rgba(29, 29, 31, 1);
        font-size: clamp(12px, 3vw, 20px);
        text-align: center;
        line-height: 1.4;
        margin-top: 1vw;
        max-width: 180px;
    }

    /* 底部内容区域 */
    .box_9 {
        width: 100%;
        padding: 5vw 0;
        align-items: center;
    }

    .block_6, .block_7 {
        width: 90%;
        max-width: 669px;
        margin: 2vw auto;
        flex-wrap: wrap;
    }

    .section_3, .box_10 {
        width: 30vw;
        height: 20vw;
        max-width: 200px;
        max-height: 142px;
        border: 0.5px solid rgba(151, 151, 151, 1);
        margin-right: 2vw;
        position: relative;
        overflow: hidden;
        cursor: pointer;
    }

    .section_3::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(../../../assets/contact/contact_join_02.png);
        background-size: cover;
        background-position: center;
        transition: transform 0.3s ease;
    }

    .box_10::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url(../../../assets/contact/contact_join_03.png);
        background-size: cover;
        background-position: center;
        transition: transform 0.3s ease;
    }

    .section_3:hover::after, .box_10:hover::after {
        transform: scale(1.1);
    }

    .text-wrapper_4, .box_11 {
        flex: 1;
        min-width: 60%;
    }

    .text_16, .text_17 {
        color: rgba(29, 29, 31, 1);
        font-size: clamp(18px, 4vw, 30px);
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        line-height: 1.4;
        margin-bottom: 2vw;
    }

    .paragraph_6, .text-wrapper_5 {
        color: rgba(102, 102, 102, 1);
        font-size: clamp(14px, 3vw, 20px);
        line-height: 1.5;
        text-align: justify;
    }

    .text_18 {
        color: rgba(37, 144, 138, 1);
        font-size: clamp(14px, 3vw, 20px);
        line-height: 1.5;
    }

    /* 加入我们区域 */
    .block_8 {
        width: 90%;
        max-width: 690px;
        background: url(../../../assets/contact/contact_bj_02.png) 100% no-repeat;
        background-size: cover;
        margin: 5vw auto 0;
        padding: 3vw;
        align-items: center;
    }

    .image_10 {
        width: 15vw;
        height: 20vw;
        max-width: 101px;
        max-height: 148px;
        margin-right: 3vw;
    }

    .text-group_7 {
        flex: 1;
    }

    .text_21 {
        color: rgba(29, 29, 31, 1);
        font-size: clamp(18px, 4vw, 24px);
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        line-height: 1.4;
        margin-bottom: 2vw;
    }

    .text-wrapper_6 {
        font-size: clamp(14px, 3vw, 22px);
        line-height: 1.5;
    }

    .text_22, .text_23, .text_25 {
        color: rgba(102, 102, 102, 1);
    }

    .text_24 {
        color: rgba(26, 128, 125, 1);
    }
</style>
